import * as React from 'react';
import { useDeviceType } from '@cian/ui-kit';

import { BackButton } from '../../components/BackButton';
import { useApplicationContext } from '../../utils/applicationContext';
import { getNewbuildingPromosSeoEnabled, getNewbuildingPromosUrl } from '../../utils/config';

export const BackButtonContainer: React.FC = () => {
  const { config } = useApplicationContext();
  const url = getNewbuildingPromosUrl(config);
  const seoEnabled = getNewbuildingPromosSeoEnabled(config);

  const deviceType = useDeviceType();

  if (deviceType !== 'phone' && seoEnabled) {
    return null;
  }

  return <BackButton url={url} title="Назад на акции и скидки" />;
};
